import { Badge, Radio, RadioGroup, Stack, StackProps } from "@chakra-ui/react";
import { useState } from "react";

interface IProps {
  items: Array<{
    label: string;
    value: string;
    badge?: string;
  }>;
  value: string;
  direction?: StackProps["direction"];
  onChange: (value: string) => void;
}

const FormRadio = ({
  items,
  value,
  direction = "column",
  onChange,
}: IProps): JSX.Element => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      onMouseOver={() => setIsVisible(true)}
      onMouseOut={() => setIsVisible(false)}
    >
      <Stack spacing={3} direction={direction}>
        {items.map((item) => (
          <Stack
            key={item.value}
            spacing={2}
            direction="row"
            alignItems="center"
          >
            <Radio
              value={item.value}
              colorScheme="checkBoxColor"
              borderColor={isVisible ? "ud-primary" : undefined}
              transition="border-color 0.2s"
            >
              {item.label}
            </Radio>
            {item.badge && (
              <Badge
                background="ud-primary"
                color="ud-white"
                textTransform="none"
              >
                {item.badge}
              </Badge>
            )}
          </Stack>
        ))}
      </Stack>
    </RadioGroup>
  );
};

export default FormRadio;
